export enum IntegrationStatusRejectCode {
  Other = 'OTHER',
  DuplicateFile = 'DUPLICATE_FILE',
  FailedToDownload = 'FAILED_TO_DOWNLOAD',
  EmptyFile = 'EMPTY_FILE',
  DuplicateDocumentId = 'DUPLICATE_DOCUMENT_ID',
}
